import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Util } from '../../../common/util/util';
import { CustomButton, Icon } from '../../../components';
import { useCatalog } from '../../../hooks/useCatalog';
import { useLayout } from '../../../hooks/useLayout';
import { IMainCatalogItem } from '../../../shared/types/main-catalog';

import './Processes.sass';
import { ProcessesItem } from './ProcessesItem';
import { getProcesses } from './utils';

interface IProcessesProps {
  className?: string;
}

export const Processes: FC<IProcessesProps> = ({ className = '' }) => {
  const { processes, page, title } = useLayout();
  const { catalog } = useCatalog();
  const [content, setContent] = useState<IMainCatalogItem[]>([]);
  const [processesLeft, setProcessesLeft] = useState<IMainCatalogItem[]>([]);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const data = getProcesses(
        processes,
        window.innerWidth > 1496 ? 1464 : window.innerWidth - 32
      );
      setProcessesLeft(data.processesLeft);
      setContent(data.content);

      if (data.processesLeft.length === 0) {
        setShowMore(false);
      }
    };

    if (window.innerWidth > 900) {
      const data = getProcesses(
        processes,
        window.innerWidth > 1496 ? 1464 : window.innerWidth - 32
      );
      setProcessesLeft(data.processesLeft);
      setContent(data.content);

      window.addEventListener('resize', handleResize);
    }

    return () => window.removeEventListener('resize', handleResize);
  }, [processes]);

  const handleShowMore = () => {
    setShowMore((prev) => !prev);
  };
  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      borderRadius: '8px',
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: 111,
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: '#fff',
      maxWidth: '500px',
      width: '100%',
    },
  }));
  const textContent = (text: string) => {
    text = text.replace(/<p>(&nbsp;)?<\/p>/gi, '');
    text = text.substring(0, 333);
    let lastIndex = text.lastIndexOf(' '); // позиция последнего пробела
    text = text.substring(0, lastIndex) + '...'; // обрезаем до последнего слова
    return text;
  };
  return (
    <>
      {((processes && processes.length > 0) || title) && (
        <>
          {page !== 'home' && page !== 'publication' && title && (
            <h1 className="processes__title">
              {title}
              {catalog &&
                catalog?.process &&
                catalog?.process?.article &&
                catalog?.process?.article.content !== null && (
                  <LightTooltip
                    placement="left-end"
                    title={
                      <div className="processes__question">
                        <div className="processes__question_wrapper">
                          <div>
                            <Icon variant="question" />
                          </div>
                          <div className="processes__question_right">
                            {catalog &&
                              catalog?.process &&
                              catalog?.process?.article && (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: Util.textByRegex(
                                      textContent(
                                        catalog?.process.article.content
                                      )
                                    ),
                                  }}
                                ></div>
                              )}
                            <CustomButton variant="orange">
                              <Link
                                to={`/articles/${catalog?.process?.article.slug}`}
                              >
                                Читать дальше
                              </Link>
                            </CustomButton>
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <div>
                      <Icon variant="question" />
                    </div>
                  </LightTooltip>
                )}
            </h1>
          )}

          {processes && processes.length > 0 && (
            <div className="processes_desktop desktop">
              <ul className={`processes__top ${className}`}>
                {content?.map((process) => {
                  return (
                    <ProcessesItem
                      key={process?.id}
                      process={process}
                      page={page}
                    />
                  );
                })}
                {processesLeft?.length > 0 &&
                  (page === 'home' || page === 'publication') && (
                    <li>
                      <CustomButton
                        variant="orange"
                        className="processes__button"
                        onClick={handleShowMore}
                      >
                        <div
                          className={
                            'processes__icon' + (showMore ? ' rotate45deg' : '')
                          }
                        >
                          <Icon variant="plusWhite" />
                        </div>
                      </CustomButton>
                    </li>
                  )}
              </ul>
              {processesLeft.length > 0 && (
                <ul
                  className={
                    'processes__bottom' +
                    (showMore || page === 'catalog' ? '' : ' display-none')
                  }
                >
                  {processesLeft.map((process) => (
                    <ProcessesItem
                      page={page}
                      process={process}
                      key={process?.id}
                    />
                  ))}
                </ul>
              )}
            </div>
          )}

          <div className={`processes_mobile mobile ${page}`}>
            <ul>
              {processes?.map((process) => (
                <ProcessesItem
                  page={page}
                  process={process}
                  key={process?.id}
                />
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
};
